export default __webpack_public_path__ + "static/media/content.cf7ce15a.png";